import useAccountMetadata from "./useAccountMetadata";
import FeatureFlag, { getFeature } from "../FeatureFlag";
import { useCallback } from "react";

export default function useFeatureFlags(): (
  featureName: FeatureFlag
) => boolean {
  const accountMetadata = useAccountMetadata();

  return useCallback(
    (featureFlag: FeatureFlag) => {
      if (!accountMetadata.loaded) {
        return false;
      }

      return getFeature(accountMetadata, featureFlag);
    },
    [accountMetadata]
  );
}
